import { useRef } from 'react';
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';

import { Button } from '../../../components/ui';
import { useT } from '../../../i18n';
import { dungLuongVN } from '../../../lib/dinh-dang';

/** Đuôi tệp backend đọc được (`trich.ts`); khai lại ở đây để nói trước thay vì để người dùng thử rồi mới biết. */
export const DUOI_NHAN = ['.pdf', '.docx', '.xlsx', '.txt', '.md', '.csv'] as const;
/** Trần của `FilesInterceptor` ở backend. */
export const TRAN_SO_TEP = 20;
export const TRAN_MOI_TEP = 50 * 1024 * 1024;

export interface ChonTepHoSoProps {
  tep: readonly File[];
  onDoi: (tep: File[]) => void;
  /** Một tệp thôi (chạy thử, tệp mẫu của gợi ý). */
  motTep?: boolean;
  nhan?: string;
}

/**
 * Ô chọn tệp hồ sơ kèm danh sách đã chọn, dùng chung cho nộp hồ sơ, nộp lại và chạy thử.
 *
 * Bỏ trùng theo **tên + kích thước**: người dùng bấm chọn hai lần và lần thứ hai chọn lại cùng tệp là chuyện
 * thường, còn hai tệp cùng tên khác kích thước thì là hai tệp thật.
 */
export function ChonTepHoSo({ tep, onDoi, motTep, nhan }: ChonTepHoSoProps) {
  const { t, locale } = useT();
  const o = useRef<HTMLInputElement>(null);
  const quaLon = tep.filter((f) => f.size > TRAN_MOI_TEP);

  function them(ds: FileList | null) {
    if (!ds) return;
    const moi = motTep ? [] : [...tep];
    for (const f of Array.from(ds)) {
      if (!moi.some((x) => x.name === f.name && x.size === f.size)) moi.push(f);
    }
    onDoi(moi.slice(0, motTep ? 1 : TRAN_SO_TEP));
    if (o.current) o.current.value = '';
  }

  return (
    <div className="space-y-2">
      <input
        ref={o}
        type="file"
        multiple={!motTep}
        accept={DUOI_NHAN.join(',')}
        aria-label={nhan ?? t('thamDinh.nop.chonTep')}
        className="block w-full text-sm text-content-secondary file:me-3 file:rounded file:border-0 file:bg-subtle file:px-3 file:py-1.5 file:text-sm file:text-content-primary"
        onChange={(e) => them(e.target.files)}
      />

      {tep.length > 0 && (
        <ul className="divide-y divide-default rounded border border-default">
          {tep.map((f, i) => (
            <li key={`${f.name}-${f.size}`} className="flex items-center gap-2 px-3 py-2">
              <InboxOutlined className="shrink-0 text-content-muted" />
              <span className="min-w-0 flex-1 truncate text-sm">{f.name}</span>
              <span className="shrink-0 text-2xs text-content-muted">{dungLuongVN(f.size, locale)}</span>
              <Button
                variant="ghost"
                size="sm"
                aria-label={t('thamDinh.nop.boTep', { ten: f.name })}
                onClick={() => onDoi(tep.filter((_, j) => j !== i))}
              >
                <DeleteOutlined />
              </Button>
            </li>
          ))}
        </ul>
      )}

      {quaLon.length > 0 && (
        <p className="text-sm text-danger-700">{t('thamDinh.nop.tepQuaLon', { ten: quaLon[0]!.name })}</p>
      )}
    </div>
  );
}
